(function () {
    'use strict';

    function requestForProposalController($scope, $rootScope, notifyService, rfpData, requestForProposalStateService, toastr) {
        var vm = this;
        vm.rfpId = rfpData.Id.split('/')[1];
        vm.rfpData = rfpData;

        vm.tabs = {
            'rfp.basicInformation': {
                header: 'Summary',
                active: true,
                additionalStates: ['rfp.search', 'rfp.informationParts']
            },
            'rfp.content': {
                header: 'Content',
                active: false,
                additionalStates: []
            },
            'rfp.findRespondents': {
                header: 'Find Respondents',
                active: false,
                additionalStates: []
            },
            'rfp.responseContent': {
                header: 'Response Content',
                active: false,
                additionalStates: []
            },
            'rfp.responses': {
                header: 'Responses',
                active: false,
                additionalStates: ['rfp.responses.single']
            }
        };

        vm.canEditContent = true;
        vm.canEditResponseContent = true;
        vm.canFindRespondents = true;
        vm.canEditResponseContent = true;

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.changeTab(toState.name);
            $('html,body').scrollTop(0);

            if ($rootScope.rfpContentReorderMode && $rootScope.rfpContentReorderModeToast) {
                toastr.clear($rootScope.rfpContentReorderModeToast);
            }

            if ($rootScope.rfpContentPreviewMode && $rootScope.rfpContentPreviewModeToast) {
                toastr.clear($rootScope.rfpContentPreviewModeToast);
            }

            $rootScope.rfpContentReorderMode = false;
            $rootScope.rfpContentPreviewMode = false;
        });

        $scope.$on('rfpUpdated', function () {
            vm.rfpData = requestForProposalStateService.get();
        });

        $scope.$on('fileUploaded', function (event, args) {
            var documentObject = vm.rfpData.InformationParts.find(function(informationPart) {
                return args.parent.Title === informationPart.Title;
            });

            if (!documentObject.BlobSummaries) {
                documentObject.BlobSummaries = [];
            }

            documentObject.BlobSummaries = documentObject.BlobSummaries.concat(args.blobs);
            requestForProposalStateService.update(vm.rfpData);
            notifyService.notify('You uploaded ' + args.blobs[0].FileName);
        });

        vm.changeTab = function (tabName) {
            for (var property in vm.tabs) {
                if (vm.tabs.hasOwnProperty(property)) {
                    vm.tabs[property].active = property === tabName || (
                        vm.tabs[property].additionalStates &&
                        vm.tabs[property].additionalStates.indexOf(tabName) !== -1);
                }
            }
        }


    }

    requestForProposalController.$inject = ['$scope', '$rootScope', 'notifyService', 'rfpData', 'requestForProposalStateService', 'toastr'];

    angular.module('ecap.requestForProposal').controller('requestForProposalController', requestForProposalController);
})();
